module.exports = "<div content>\n    <p class=\"subTitle ng-binding\">\n        {{content('bank.bankDescription')}}\n    </p>\n\n    <button class=\"btn\" id=\"teslaAddBankSubmit\" ng-click=\"actions.onContinueClick($event)\">{{content('common.continueLabel')}}</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-guest-components/src/guest/tesla-add-bank/template.html
// module id = ../node_modules/xo-guest-components/src/guest/tesla-add-bank/template.html
// module chunks = 0